import { cn, formatNumber } from "@/lib/utils";

export type MetricUnit = "rub" | "percent" | "pieces" | "none";

type MetricCellProps = {
  value: number | null | undefined;
  unit?: MetricUnit;
  className?: string;
};

const metricUnitClassName: Record<MetricUnit, string | undefined> = {
  rub: "metric-cell--rub",
  percent: "metric-cell--percent",
  pieces: "metric-cell--pieces",
  none: undefined,
};

export function MetricCell({ value, unit = "none", className }: MetricCellProps) {
  if (value == null || Number.isNaN(value)) {
    return <span className="text-muted-foreground">-</span>;
  }

  return (
    <span
      className={cn(
        "metric-cell block max-w-full truncate whitespace-nowrap",
        metricUnitClassName[unit],
        className
      )}
    >
      {formatNumber(value)}
    </span>
  );
}
